export const refreshToken = async () => {
  const response = await fetch(window.envVariables.REACT_APP_BASE_URL + '/int-api/auth/refresh', {
    credentials: 'include',
    method: 'GET',
  })
  if (!response.ok) {
    throw new Error('Refresh token failed')
  }
  const data = await response.json()
  return { access_token: data.e360_auth.access_token as string | null }
}
